// Перенос функций из src_ui/web/src/screens/menu/parts.tsx — дословно (без React-части;
// компоненты живут рядом отдельными .svelte).
import { getLang, t } from '../i18n.js';

const loc = () => (getLang() === 'en' ? 'en-US' : 'ru-RU');
export const money = (n) => '$' + Math.round(n || 0).toLocaleString(loc());
export const num = (n) => Math.round(n || 0).toLocaleString(loc());

/**
 * Донат-валюта проекта. В старом меню её звали то RB, то CC, то C-coins, то JC
 * (в анимациях). Правило одно: везде **JC** — Just Coins.
 */
export const cc = (n) => num(n) + ' JC';

/** Минуты → «12 ч 30 м» / «3 д 4 ч». Время в игре геймод отдаёт в минутах. */
export function playtime(minutes) {
  const m = Math.max(0, Math.round(minutes || 0));
  const d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
  const en = getLang() === 'en';
  if (d > 0) return `${d}${en ? 'd' : ' д'} ${h}${en ? 'h' : ' ч'}`;
  if (h > 0) return `${h}${en ? 'h' : ' ч'} ${mm}${en ? 'm' : ' м'}`;
  return `${mm}${en ? 'm' : ' м'}`;
}

/** «в игре с» — сколько прошло от даты регистрации, крупными единицами. */
export function since(iso) {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  if (!isFinite(ms) || ms < 0) return '—';
  const days = Math.floor(ms / 86400000);
  const en = getLang() === 'en';
  if (days >= 365) { const y = Math.floor(days / 365); return `${y} ${en ? 'yr' : 'г.'}`; }
  if (days >= 30) { const mo = Math.floor(days / 30); return `${mo} ${en ? 'mo' : 'мес.'}`; }
  return `${days} ${en ? 'd' : 'дн.'}`;
}

export const dmy = (iso) =>
  iso ? new Date(iso).toLocaleDateString(loc(), { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—';

/** Минуты → «ЧЧ:ММ». Таймеры геймод отдаёт в минутах, секунды не показываем. */
export const hhmm = (min) => {
  const m = Math.max(0, Math.round(min || 0));
  return String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');
};

/** Инициалы из «Имя Фамилия» / «Имя_Фамилия» — для монограмм. */
export const initials = (name) =>
  String(name || '?').replace(/_/g, ' ').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || '?';

export { t };
